<div class="flex flex-col gap-1 w-full h-full" matAutocompleteOrigin>
  <p class="text-sm label" *ngIf="label">{{ label }}</p>
  <div
    class="flex relative flex-row gap-2 px-2 py-0 w-full border border-cool-gray-300 ts-input min-h-ts-field-height align-center"
    [ngClass]="{
      rounded: roundedBorders,
      slim: variant === 'slim',
      large: size === 'lg',
      sm: size === 'sm',
    }"
  >
    <ts-icon [ngStyle]="{ width: 'fit-content' }" *ngIf="icon" [icon]="icon" color="black"></ts-icon>
    <input
      class="w-full"
      [readonly]="readonly"
      [attr.data-cy]="dataCy"
      [autofocus]="autofocus"
      [type]="inputType"
      [tabIndex]="tabindex"
      [placeholder]="placeholder"
      [formControl]="control"
      [autocomplete]="autocomplete"
      [maxlength]="maxlength"
      [min]="min"
      [max]="max"
      [step]="step"
      [matAutocompletePosition]="'auto'"
      [matAutocomplete]="matAutocompleteComponentRef"
      [matAutocompleteDisabled]="!autoCompleteComponentRef"
      (blur)="blur.emit()"
    />
    <ts-icon
      class="absolute top-1/2 left-full transform scale-90 -translate-x-6 -translate-y-1/2 cursor-pointer focus:outline-black w-fit-content"
      tabindex="0"
      *ngIf="clearable && control?.value"
      icon="ts_close"
      color="light-gray"
      (click)="control.setValue('')"
      (keydown.enter)="control.setValue('')"
    ></ts-icon>
    <ng-content select="[ts-autocomplete]"></ng-content>
  </div>

  <div *ngIf="control?.errors && errorMessages">
    <ng-container *ngFor="let error of control?.errors | keyvalue">
      <p class="mb-1 text-sm text-danger" *ngIf="errorMessages[error.key]?.length > 0">
        {{ errorMessages[error.key] }}
      </p>
    </ng-container>
  </div>
</div>
